import { SWIFTFOX_PALETTE } from '@fox/atoms/palette';
import { alpha } from '@mui/material/styles';

export const lightTheme = {
	palette: {
		mode: 'light',
		text: {
			header: SWIFTFOX_PALETTE.blue['60-midnight'],
			primary: SWIFTFOX_PALETTE.neutral['70-nearlyBlack'],
			secondary: SWIFTFOX_PALETTE.neutral['60-darkGrey'],
			disabled: SWIFTFOX_PALETTE.neutral['50-midGrey'],
			_link: {
				default: SWIFTFOX_PALETTE.blue['40-coreBlue'],
				visited: SWIFTFOX_PALETTE.purple['50-amethyst']
			},
			_states: {
				selected: alpha(SWIFTFOX_PALETTE.neutral['70-nearlyBlack'], 0.08),
				hover: alpha(SWIFTFOX_PALETTE.neutral['70-nearlyBlack'], 0.04),
				focus: alpha(SWIFTFOX_PALETTE.neutral['70-nearlyBlack'], 0.12),
				focusVisible: alpha(SWIFTFOX_PALETTE.neutral['70-nearlyBlack'], 0.3)
			},
			_fontColour: {
				body: SWIFTFOX_PALETTE.blue['60-midnight'],
				primary: SWIFTFOX_PALETTE.blue['40-coreBlue']
			},
			highlight: {
				background: SWIFTFOX_PALETTE.blue['40-coreBlue'],
				foreground: SWIFTFOX_PALETTE.neutral['10-almostWhite']
			}
		},
		primary: {
			main: SWIFTFOX_PALETTE.blue['40-coreBlue'],
			dark: SWIFTFOX_PALETTE.blue['50-deepOcean'],
			light: SWIFTFOX_PALETTE.blue['10-icyMist'],
			contrastText: SWIFTFOX_PALETTE.neutral['10-almostWhite'],
			_states: {
				hover: SWIFTFOX_PALETTE.blue['30-skywave'],
				selected: SWIFTFOX_PALETTE.blue['20-frostedAzure'],
				focus: SWIFTFOX_PALETTE.blue['30-skywave'],
				focusVisible: SWIFTFOX_PALETTE.blue['20-frostedAzure'],
				outlinedBorder: SWIFTFOX_PALETTE.blue['20-frostedAzure'],
				fill: SWIFTFOX_PALETTE.blue['10-icyMist']
			}
		},
		secondary: {
			main: SWIFTFOX_PALETTE.blue['60-midnight'],
			// TODO: Find brand colour for this
			dark: '#08152E',
			light: SWIFTFOX_PALETTE.blue['50-deepOcean'],
			contrast: SWIFTFOX_PALETTE.neutral['10-almostWhite'],
			_states: {
				hover: SWIFTFOX_PALETTE.blue['10-icyMist'],
				selected: SWIFTFOX_PALETTE.blue['40-coreBlue'],
				focus: SWIFTFOX_PALETTE.blue['60-midnight'],
				focusVisible: SWIFTFOX_PALETTE.blue['20-frostedAzure'],
				outlinedBorder: alpha(SWIFTFOX_PALETTE.blue['60-midnight'], 0.56)
			}
		},
		action: {
			active: alpha(SWIFTFOX_PALETTE.blue['60-midnight'], 0.7),
			hover: alpha(SWIFTFOX_PALETTE.blue['60-midnight'], 0.04),
			selected: alpha(SWIFTFOX_PALETTE.blue['60-midnight'], 0.08),
			focus: alpha(SWIFTFOX_PALETTE.blue['60-midnight'], 0.08),
			disabled: alpha(SWIFTFOX_PALETTE.blue['60-midnight'], 0.38),
			disabledBackground: alpha(SWIFTFOX_PALETTE.blue['60-midnight'], 0.12)
		},
		common: {
			black_states: {
				main: SWIFTFOX_PALETTE.neutral['70-nearlyBlack']
			},
			white_states: {
				main: SWIFTFOX_PALETTE.neutral['10-almostWhite'],
				hover: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.04),
				selected: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.08),
				focus: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.12),
				focusVisible: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.3),
				outlinedBorder: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.5)
			}
		},
		background: {
			default: SWIFTFOX_PALETTE.neutral['10-almostWhite'],
			'paper-elevation-0': SWIFTFOX_PALETTE.neutral['20-offWhite'],
			'paper-elevation-1': SWIFTFOX_PALETTE.neutral['10-almostWhite'],
			'paper-elevation-2': SWIFTFOX_PALETTE.neutral['10-almostWhite'],
			'paper-elevation-3': SWIFTFOX_PALETTE.neutral['20-offWhite'],
			'paper-colour': SWIFTFOX_PALETTE.blue['05-glacialAir']
			// paper: SWIFTFOX_PALETTE.blue['05-glacialAir']
		},
		divider: alpha(SWIFTFOX_PALETTE.blue['20-frostedAzure'], 0.4),
		elevation: {
			outlined: SWIFTFOX_PALETTE.neutral['30-lightGrey'],
			shadow: {
				'alpha-1': alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.01),
				'alpha-2': alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.02),
				'alpha-3': alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.03),
				'alpha-4': alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.04),
				'alpha-5': alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.08),
				'alpha-6': alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.12),
				'alpha-7': alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.14),
				'alpha-8': alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.18),
				'alpha-9': alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.22)
			}
		},
		_components: {
			timelineDot: SWIFTFOX_PALETTE.blue['40-coreBlue'],
			avatar: {
				fill: SWIFTFOX_PALETTE.neutral['40-justGrey']
			},
			input: {
				standard: {
					enabledBorder: SWIFTFOX_PALETTE.neutral['50-midGrey'],
					hoverBorder: SWIFTFOX_PALETTE.blue['60-midnight']
				},
				filled: {
					enabledFill: SWIFTFOX_PALETTE.neutral['20-offWhite'],
					hoverFill: SWIFTFOX_PALETTE.neutral['20-offWhite']
				},
				outlined: {
					enabledBorder: SWIFTFOX_PALETTE.neutral['40-justGrey'],
					hoverBorder: SWIFTFOX_PALETTE.blue['60-midnight']
				}
			},
			featureMenu: SWIFTFOX_PALETTE.blue['60-midnight'],
			switch: {
				knobFillEnabled: SWIFTFOX_PALETTE.neutral['10-almostWhite'],
				slideFill: SWIFTFOX_PALETTE.neutral['40-justGrey'],
				knowFillDisabled: SWIFTFOX_PALETTE.neutral['20-offWhite']
			},
			rating: {
				activeFill: SWIFTFOX_PALETTE.orange['30-highlight']
			},
			snackbar: {
				fill: SWIFTFOX_PALETTE.blue['60-midnight']
			},
			tooltip: {
				fill: SWIFTFOX_PALETTE.blue['60-midnight']
			},
			backdrop: {
				fill: alpha(SWIFTFOX_PALETTE.blue['60-midnight'], 0.25)
			}
		},
		error: {
			main: '#D43D3D',
			dark: '#A32828',
			light: '#FF8093',
			_states: {
				hover: 'rgba(222, 105, 105, 0.04)',
				selected: 'rgba(222, 105, 105, 0.08)',
				focusVisible: 'rgba(222, 105, 105, 0.3)',
				outlinedBorder: 'rgba(222, 105, 105, 0.5)'
			},
			contrastText: SWIFTFOX_PALETTE.neutral['10-almostWhite']
		},
		warning: {
			main: '#9A5A00',
			dark: '#6B3E00',
			light: '#FFCD75',
			_states: {
				hover: 'rgba(255, 167, 38, 0.04)',
				selected: 'rgba(255, 167, 38, 0.08)',
				focusVisible: 'rgba(255, 167, 38, 0.3)',
				outlinedBorder: 'rgba(255, 167, 38, 0.5)'
			},
			contrastText: SWIFTFOX_PALETTE.neutral['10-almostWhite']
		},
		info: {
			main: '#0F6E92',
			dark: '#094A62',
			light: '#94DAF0',
			_states: {
				hover: 'rgba(13, 145, 232, 0.04)',
				selected: 'rgba(13, 145, 232, 0.08)',
				focusVisible: 'rgba(13, 145, 232, 0.3)',
				outlinedBorder: 'rgba(13, 145, 232, 0.5)'
			},
			contrastText: SWIFTFOX_PALETTE.neutral['10-almostWhite']
		},
		success: {
			main: '#187F5E',
			dark: '#0D5A45',
			light: '#A0E8D3',
			_states: {
				hover: 'rgba(24, 127, 94, 0.04)',
				selected: 'rgba(24, 127, 94, 0.08)',
				focusVisible: 'rgba(24, 127, 94, 0.3)',
				outlinedBorder: 'rgba(24, 127, 94, 0.5)'
			},
			contrastText: SWIFTFOX_PALETTE.neutral['10-almostWhite']
		}
	} as const
} as const;
